import React from 'react';
import './NoDataCard.css';

const NoDataCard = ({
  title = "No Data Found",
  message = "There are no items to display at the moment.",
  icon = "📄",
  actionButton = null,
  className = "",
  style = {}
}) => {
  return (
    <div className={`no-data-card ${className}`} style={style}>
      <div className="no-data-content">
        <div className="no-data-icon">
          {icon}
        </div>
        <h3 className="no-data-title">{title}</h3>
        <p className="no-data-message">{message}</p>
        {actionButton && (
          <div className="no-data-action">
            {actionButton}
          </div>
        )}
      </div>
    </div>
  );
};

export default NoDataCard;